<template>

  <svg
    t="1639131194870"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3988"
    width="64"
    height="64"
  ><path d="M544.95898438 854.7734375l-65.91796876 0 0-672.36328125L544.95898438 182.41015625z" p-id="3989" /><path d="M718.32324219 607.58105469l45.48339843 44.82421874L512 904.21191405l-251.80664063-251.80664062 45.48339844-44.82421874L512 813.90429688zM933.875 182.41015625l-843.75 0 0-65.91796875L933.875 116.4921875zM933.875 419.71484375l-329.58984375 0 0-65.91796875L933.875 353.796875zM419.71484375 419.71484375l-329.58984375 0 0-65.91796875L419.71484375 353.796875z" p-id="3990" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMoveDown',
} as DefineComponent
</script>